import { render, staticRenderFns } from "./TargetDeptsEditor.vue?vue&type=template&id=bfa5d6c2&scoped=true&"
import script from "./TargetDeptsEditor.vue?vue&type=script&lang=js&"
export * from "./TargetDeptsEditor.vue?vue&type=script&lang=js&"
import style0 from "./TargetDeptsEditor.vue?vue&type=style&index=0&id=bfa5d6c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa5d6c2",
  null
  
)

export default component.exports